import React from 'react'
import Dialog from '@mui/material/Dialog'
import clsx from 'clsx'
import lang from '@/lang'
import PropTypes from 'prop-types'

import styles from './confirm-modal.css'
import IconCheck from '@assets/images/icons/check.svg'
import ButtonIconSquare from '@/modules/base/components/buttons/icon-square/button-icon-square'
import CancelButton from '@/modules/base/components/buttons/cancel-button/cancel-button'

const ConfirmModal = (props) => {
  const {
    title,
    description,
    children,
    abortButtonLabel = lang.cancelButtonLabel,
    confirmButtonLabel = lang.confirmButtonLabel,
    confirmButtonIcon = IconCheck,
    open,
    onAbort,
    onConfirm,
    onPanic,
    disableBackdropClick,
    disableEscapeKeyDown,
    icon = null,
    noCancel = false,
    descriptionAsHtml = false,
    disableModalButton,
    debounceTimeConfirm,
    dataQsId,
    paperClassName,
  } = props

  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return false
    }

    if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
      return false
    }

    if (['backdropClick', 'escapeKeyDown'].includes(reason) && onPanic) {
      return onPanic()
    }

    if (typeof onAbort === 'function') {
      onAbort()
    }
  }

  let descriptionContent = null
  if (description) {
    descriptionContent = <div className={styles.content}>{description}</div>
    if (descriptionAsHtml) {
      descriptionContent = <div className={styles.content} dangerouslySetInnerHTML={{ __html: description }}></div>
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{
        paper: clsx(styles.paper, paperClassName),
      }}
      data-qs-id={dataQsId}>
      <div className={styles.container}>
        {icon}
        <span className={styles.title}>{title}</span>
        {descriptionContent}
        {children}
        <div className={styles.footer}>
          {!noCancel && <CancelButton
            label={abortButtonLabel}
            onClick={onAbort}
            disabled={disableModalButton} />}
          <ButtonIconSquare
            debounceTime={debounceTimeConfirm}
            disabled={disableModalButton}
            icon={confirmButtonIcon}
            label={confirmButtonLabel}
            customClass={styles.save}
            onClick={onConfirm} />
        </div>
      </div>
    </Dialog>
  )
}

ConfirmModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  debounceTimeConfirm: PropTypes.number,
  abortButtonLabel: PropTypes.string,
  confirmButtonLabel: PropTypes.string,
  confirmButtonIcon: PropTypes.node,
  open: PropTypes.bool,
  onAbort: PropTypes.func,
  onConfirm: PropTypes.func,
  onPanic: PropTypes.func,
  descriptionAsHtml: PropTypes.bool,
  dataQsId: PropTypes.string.isRequired,
  paperClassName: PropTypes.string,
}

export default ConfirmModal
